import React, { useState, useCallback } from 'react';
import { loginUser } from '../utils/api';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setUser } from '../redux/reducers/userSlice';

const LoginPage = () => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const dispatch = useDispatch();

	const handleSubmit = useCallback(async (e) => {
		e.preventDefault();
		setIsLoading(true);

		try {
			const response = await loginUser(username, password);
			localStorage.setItem('token', response.token);
			toast.success(response.message);
			dispatch(setUser(response.data));
			window.location.href = '/home';
		} catch (err) {
			// console.log(">>> err:", err);
			toast.error(err.message);
		} finally {
			setIsLoading(false);
		}
	}, [username, password, dispatch]);

	// to do: implement a logout functionality
	// 			- possibly include a logout functionality after x time session

	return (
		<div className='login-register-container'>
			<img style={{ width: "50vw" }} src='assets/bytewise-logo.png' alt='bytewise-logo' />
			<h5 className='login-header'>Welcome back!</h5>
			<form onSubmit={handleSubmit} className='login-register-form'>
				<label>
					<input
						className='login-register-input-box'
						placeholder='Username'
						type="text"
						value={username}
						onChange={(e) => setUsername(e.target.value)}
						required
					/>
				</label>
				<label>
					<input
						className='login-register-input-box'
						placeholder='Password'
						type={showPassword ? "text" : "password"}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
					/>
					<button
						type="button"
						className="absolute right-10 top-1/2 transform -translate-y-1/2"
						onClick={() => setShowPassword(!showPassword)}
					>
						{showPassword ? "Hide" : "Show"}
					</button>
				</label>
				<button
					type="submit"
					className='submit-btn'
					disabled={isLoading}
				>
					{isLoading ? (
						<>
							<span className="spinner"></span>
							<span>Logging in...</span>
						</>
					) : (
						'Login'
					)}
				</button>
			</form>
		</div>
	);
};

export default LoginPage;